<div class="container padding-top padding-bottom">
  <md-card>
    <div class="row padding-bottom">
      <div class="col-md-12">
        <button class="btn btn-primary"
                color="primary"
                (click)="goBack()">Go Back</button>
      </div>
      <div class="col-md-12 text-center">
        <img src="{{ (client | async)?.logoUrl }}"
             class="logo"
             alt="">
        <h1>{{ (client | async)?.name}}</h1>
        <h3><b>{{ (location | async)?.name}}</b></h3>
      </div>
    </div>

    <div class="row padding-bottom">
      <div class="col-md-10 col-md-offset-1 text-center">
        <p class="big">Managers Signature</p>
        <signature-pad [options]="signaturePadOptions"></signature-pad>
        <button class="btn btn-default"
                class="float-left"
                (click)="clearSignature()">Clear</button>
      </div>
    </div>

    <div class="row padding-bottom">
      <div class="col-md-3">
        <p class="big">The office Manager's name:</p>
        <p><b>&lt;Employee.Name&gt;</b></p>
        <input class="form-control"
               type="text"
               [(ngModel)]="leaseVars.employeeName">
      </div>
      <div class="col-md-3">
        <p class="big">Payments made after this day of the month are subject to a late fee:</p>
        <p><b>&lt;Rent.LateDay&gt;</b> <b>&</b> <b>&lt;Tenant.LateDay&gt;</b></p>
        <input class="form-control half-width"
               type="number"
               [(ngModel)]="leaseVars.lateDay">
      </div>
      <div class="col-md-3">
        <p class="big">Gate access denied if payments not made by this day of the month:</p>
        <p><b>&lt;Rent.LateNoGateAccess&gt;</b></p>
        <input class="form-control half-width"
               type="number"
               [(ngModel)]="leaseVars.lateNoGateAccess">
      </div>
      <div class="col-md-3">
        <p class="big">Unit is overlocked if payments not made by this day of the month:</p>
        <p><b>&lt;Rent.LateOverLockDay&gt;</b></p>
        <input class="form-control half-width"
               type="number"
               [(ngModel)]="leaseVars.lateOverlock">
      </div>
    </div>

    <div class="row padding-top padding-bottom">
      <div class="col-md-3">
        <p class="big">Late Fee Type</p>
        <select class="form-control"
                name="source"
                [(ngModel)]="leaseVars.lateFeeType">
          <option value="percent">Percent %</option>
          <option value="flat">Flat Fee</option>
        </select>
        <br>
        <div *ngIf="leaseVars.lateFeeType == 'flat'">
          <p class="big">Default late fee #1 for overdue rent:</p>
          <p><b>&lt;Fee.LateFee1&gt;</b></p>
          <input class="form-control half-width"
                 type="text"
                 [(ngModel)]="leaseVars.lateFee">
        </div>
        <div *ngIf="leaseVars.lateFeeType == 'percent'">
          <p class="big">Default late fee #1 for overdue rent as percent of rent:</p>
          <p><b>&lt;Fee.LateAsPercent1&gt;</b></p>
          <input class="form-control half-width"
                 type="number"
                 [(ngModel)]="leaseVars.lateFeePercent">
        </div>
      </div>
      <div class="col-md-3">
        <p class="big">Late Fee 2 Type</p>
        <select class="form-control"
                name="source"
                [(ngModel)]="leaseVars.lateFee2Type">
          <option value="percent">Percent %</option>
          <option value="flat">Flat Fee</option>
        </select>
        <br>
        <div *ngIf="leaseVars.lateFee2Type == 'flat'">
          <p class="big">Default late fee #2 for overdue rent:</p>
          <p>
            <b>&lt;Fee.LateFee2&gt;</b>
          </p>
          <input class="form-control half-width"
                 type="text"
                 [(ngModel)]="leaseVars.lateFee2">
        </div>
        <div *ngIf="leaseVars.lateFee2Type == 'percent'">
          <p class="big">Default late fee #2 for overdue rent as percent of rent:</p>
          <p>
            <b>&lt;Fee.LateAsPercent2&gt;</b>
          </p>
          <input class="form-control half-width"
                 type="number"
                 [(ngModel)]="leaseVars.lateFee2Percent">
        </div>
      </div>
      <div class="col-md-3">
        <p class="big">Tenant fee for non sufficient funds check:</p>
        <p><b>&lt;Tenant.FeeBadCheck&gt;</b></p>
        <input class="form-control half-width"
               type="text"
               [(ngModel)]="leaseVars.badCheckFee">
      </div>
      <div class="col-md-3">
        <p class="big">Tenant admininistrative fee for new lease:</p>
        <p><b>&lt;Tenant.FeeAdmin&gt;</b></p>
        <input class="form-control half-width"
               type="text"
               [(ngModel)]="leaseVars.adminFee">
      </div>
    </div>


    <div class="row padding-bottom">
      <div class="col-md-3">
        <p class="big">Default cutting lock fee:</p>
        <p><b>&lt;Fee.CutLock&gt;</b> <b>&</b> <b>&lt;Tenant.FeeCutLock&gt;</b></p>
        <input class="form-control half-width"
               type="text"
               [(ngModel)]="leaseVars.cutLockFee">
      </div>
      <div class="col-md-3">
        <p class="big">Default auction fee:</p>
        <p><b>&lt;Fee.Auction&gt;</b> <b>&</b> <b>&lt;Tenant.FeeAuction&gt;</b> <b>&</b> <b>&lt;Tenant.Auction&gt;</b>
        </p>
        <input class="form-control half-width"
               type="text"
               [(ngModel)]="leaseVars.auctionFee">
      </div>
      <div class="col-md-3">
        <p class="big">Billing Type</p>
        <select class="form-control"
                name="source"
                [(ngModel)]="leaseVars.billingType">
          <option value="static">Static</option>
          <option value="anniversary">Anniversary</option>
        </select>
        <br>
        <p class="big"
           *ngIf="leaseVars.billingType == 'static'">Day of the month rent is due:</p>
        <p class="big"
           *ngIf="leaseVars.billingType == 'anniversary'">Days after move in date rent is due:</p>
        <p>
          <b>&lt;Tenant.DueDay&gt;</b>
        </p>
        <input class="form-control half-width"
               type="number"
               [(ngModel)]="leaseVars.billingDueDay">
      </div>
      <div class="col-md-3">
        <p class="big">Electricity</p>
        <p>
          <b>Yes Text</b>
        </p>
        <input class="form-control half-width"
               [(ngModel)]="leaseVars.electricityYesText">
        <p>
          <b>No Text</b>
        </p>
        <input class="form-control half-width"
               [(ngModel)]="leaseVars.electricityNoText">
      </div>
    </div>
    <div class="row padding-bottom">
      <div class="col-md-3">
        <p class="big">Insurance Site/Location ID:</p>
        <input class="form-control"
               type="text"
               [(ngModel)]="leaseVars.insuranceLocationId">
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <button class="float-right"
                (click)="save()"
                class="btn btn-secondary"
                color="accent">Save</button>
      </div>
    </div>

    <div class="row padding-top padding-bottom mt-5">
      <div class="col-xs-12">
        <div *ngIf="!chargesData; else chargesList"
             style="text-align:center">
          <button (click)="loadChargeTypes()"
                  class="btn btn-primary"
                  style="font-size:39px"
                  color="primary">Load Charge Types</button>
        </div>
        <ng-template #chargesList>
          <div>
            <input pInputText
                   (keyup)="filter()"
                   placeholder="search"
                   [(ngModel)]="filterText">
          </div>
          <div class="charges-list">
            <div *ngFor="let c of filteredData"
                 class="charge my-4">
              <table class="table table-bordered table-striped table-hover">
                <tr>
                  <td>Charge Description</td>
                  <td>{{ c.sChgDesc }}</td>
                </tr>
                <tr>
                  <td>Charge Price</td>
                  <td>{{ c.dcPrice | currency:'USD':'symbol-narrow':'.2-2' }}</td>
                </tr>
                <tr>
                  <td>Charge % Rate</td>
                  <td>{{ c.dcPCRate }}</td>
                </tr>
                <tr>
                  <td>Charge Type</td>
                  <td>{{ c.iPriceType === 1 ? 'Percentage' : 'Fixed' }}</td>
                </tr>
              </table>
            </div>
          </div>
        </ng-template>
      </div>
    </div>

  </md-card>
</div>



// WEBPACK FOOTER //
// ./src/ng2/app/admin-portal/forms-retrieve-setting-variables/forms-retrieve-setting-variables.component.html